<template>
	<div class="gb-chart-bar" 
		v-bind:class="classChartBar"
		v-bind:style="styleChartBar"
	>
		<div class="lable-title" 
			v-if="schedule.title != ''"
			v-statemachine="sm_title">
				{{schedule.title}}
		</div>
		<label class="lable-progress-rate"
			v-if="showProgressRate">{{schedule.progress_rate}}%</label>
		<div v-statemachine= "sm_bar">
			<div class="propgress-rate"
				v-if="showProgressRate">
				<div class="progress-rate-body"
					v-bind:style="styleProgressRateBody"></div>
			</div>
			<div class="schedule"
				v-bind:class="classSchedule"
				v-bind:style="styleScheduleColor">
			</div>
			<div class="bar-stretch">
				<div class="left"
					v-bind:class="classBothEnds"
					v-statemachine= "sm_begin"
				>
					<div v-bind:class="styleTriangleLeft" />
				</div>
				<div class="right"
					v-bind:class="classBothEnds"
					v-statemachine= "sm_end"
				>
					<div v-bind:class="styleTriangleRight" />
				</div>
				<div class="bar-name">{{parent.name}}</div>
				<v-btn color="error" fab small dark
					v-if="long_press_active"
					v-on:click= "onDeleteScheduleClick"
				>
					<v-icon>close</v-icon>
				</v-btn>
			</div>
		</div>
	</div>
</template>
<script>
import EventTarget from '../data/EventTarget';
import BarEventTarget from '../data/BarEventTarget';
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';
import DataSetManager from '../classes/DataSetManager';
import { UNIT_WIDTH } from '../data/Const';
import Notification from '../classes/Notification';
import Util from '../classes/Util';
import ScheduleListRow from '../data/ScheduleListRow';
import Color from '../data/Color';

const THRESHOLD = 2;
export default {
	name: 'GBBar',
	props: [
		"schedule",
		"parent",
		"isEditable",
		"isParent",
	],
	data: function() {
		const state_nop = new MouseState({});
		const state_window_default = new MouseState({
			up: (e, next) => {
				this.$store.dispatch('endExclusive');
				next(this.state_nop);
			},
		});
		
		return {
			state_nop: state_nop,
			state_window_default: state_window_default,
			sm_bar: new MouseStateMachine(state_nop),
			sm_begin: new MouseStateMachine(state_nop),
			sm_end: new MouseStateMachine(state_nop),
			sm_window: new MouseStateMachine(state_nop),
			sm_title: new MouseStateMachine(state_nop),
			long_press_active : false,
			dataset_manager: this.$store.getters.datasetManager,
			mouse_pointer: {
				x: 0,
				y: 0,
			},
		};
	},
	mounted: function() {
		this.changeState();
	},
	methods: {
		onLongPressActivate: function(e) {
			e.stopPropagation();
			this.long_press_active = true;
			this.$emit('bar-move-break');
		},
		onLongPressDeactivate: function(e) {
			if (e)
				e.stopPropagation();
			this.long_press_active = false;
		},
		onDeleteScheduleClick: function() {
			this.dataset_manager.setBeforeDataset();
			
			this.$store.dispatch('deleteScheduleFromParent', {
				project_code: this.schedule.project_code,
				member_code: this.schedule.member_code,
				schedule_code: this.schedule.code,
			});
			this.updateDataSet();
		},
		changeState: function () {
			this.sm_bar.next(this.defaultStateBar());
			this.sm_begin.next(this.defaultStateBegin());
			this.sm_end.next(this.defaultStateEnd());
			this.sm_title.next(this.defaultStateTitle());
			this.sm_window.next(this.state_nop);
		},
		defaultStateBar: function() {
			if (!this.isEditable) {
				if(this.$store.getters.isDisplayListTypeMember && this.isParent)
					return this.state_nop;
				
				const state_watch_default = new MouseState({
					down: (e) => {
						let obj = e.targetTouches ? e.targetTouches[0] : e;
						this.mouse_pointer.x = obj.screenX;
						this.mouse_pointer.y = obj.screenY;
					},
					up: (e) => {
						let obj = e.changedTouches ? e.changedTouches[0] : e;
						let diff_x = Math.abs(this.mouse_pointer.x - obj.screenX);
						let diff_y = Math.abs(this.mouse_pointer.y - obj.screenY);
						if ((diff_x < THRESHOLD) && (diff_y < THRESHOLD)) {
							this.sm_bar.next(state_watch_click);
						} else {
							this.changeState();
						}
					},
				});
				const state_watch_click = new MouseState({
					longclick: (e) => {
						e.stopPropagation();
						this.changeState();
					},
					click: (e) => {
						e.stopPropagation();
						this.$emit("progress-rate-setting", {
							schedule: this.schedule,
							item_type: this.parent.item_type,
							callback: () => {
								this.changeState();
							},
						});
					},
				});
				
				return state_watch_default;
			}

			const state_default = new MouseState({
				down: (e) => {
					this.$store.dispatch('startExclusive');
					e.stopPropagation();
					
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					this.$emit('bar-move-start',  new BarEventTarget({
						target: this,
						target_type: EventTarget.TARGET_TYPE.SCHEDULE_MOVE,
						x: obj.pageX,
					}));
					this.$emit('request-ghost-schedule', this.schedule);
					this.sm_window.next(this.state_window_default);
				},
				move: (e) => {
					e.preventDefault();
				},
				longpress: (e) => {
					this.$store.dispatch('endExclusive');
					this.$emit('bar-move-break');
					this.onLongPressActivate(e);
					this.sm_window.next(state_goto_longpressed);
				},
			});
			const state_goto_longpressed = new MouseState({
				up: (e) => {
					e.stopPropagation();
					this.changeState();
				},
			});
			const state_longpressed = new MouseState({
				down: (e) => {
					e.stopPropagation();
				},
				click: (e) => {
					e.stopPropagation();
					this.$emit("progress-rate-setting", {
						schedule: this.schedule,
						item_type: this.parent.item_type,
						callback: () => {
							this.onLongPressDeactivate();
							this.changeState();
						},
					});
				},
				longpress: (e) => {
					this.onLongPressDeactivate(e);
					this.sm_window.next(state_backto_default);
				},
			});
			const state_backto_default = new MouseState({
				up: (e) => {
					e.stopPropagation();
					this.changeState();
				},
			});
			return this.long_press_active ? state_longpressed : state_default;
		},
		defaultStateBegin: function() {
			if (!this.isEditable)
				return this.state_nop;

			const state_defalt = new MouseState({
				down: (e) => {
					this.$store.dispatch('startExclusive');
					e.stopPropagation();
					
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					this.$emit('bar-stretch-start', new BarEventTarget({
						target: this,
						target_type: EventTarget.TARGET_TYPE.SCHEDULE_STRECH_BEGIN,
						x: obj.pageX,
					}));
					this.$emit('request-ghost-schedule', this.schedule);
				},
				move: (e) => {
					e.preventDefault();
				},
				longpress: (e) => {
					this.$store.dispatch('endExclusive');
					this.onLongPressActivate(e);
					this.sm_window.next(state_goto_longpressed);
				},
			});
			const state_goto_longpressed = new MouseState({
				up: (e) => {
					e.stopPropagation();
					this.changeState();
				},
			});
			const state_longpressed = new MouseState({
				down: (e) => {
					e.stopPropagation();
				},
				longclick: (e) => {
					e.stopPropagation();
				},
				longpress: () => {
					this.onLongPressDeactivate();
					this.sm_window.next(state_backto_default);
				},
			});
			const state_backto_default = new MouseState({
				up: (e) => {
					e.stopPropagation();
					this.changeState();
				},
			});
			
			return this.long_press_active ? state_longpressed : state_defalt;
		},
		defaultStateEnd: function() {
			if (!this.isEditable)
				return this.state_nop;

			const state_default = new MouseState({
				down: (e) => {
					this.$store.dispatch('startExclusive');
					e.stopPropagation();
					
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					this.$emit('bar-stretch-start', new BarEventTarget({
						target: this,
						target_type: EventTarget.TARGET_TYPE.SCHEDULE_STRECH_END,
						x: obj.pageX,
					}));
					this.$emit('request-ghost-schedule', this.schedule);
				},
				longpress: (e) => {
					this.$store.dispatch('endExclusive');
					this.onLongPressActivate(e);
					this.sm_window.next(state_goto_longpressed);
				},
			});
			const state_goto_longpressed = new MouseState({
				up: (e) => {
					e.stopPropagation();
					this.changeState();
				},
			});
			const state_longpressed = new MouseState({
				down: (e) => {
					e.stopPropagation();
				},
				longclick: (e) => {
					e.stopPropagation();
				},
				longpress: () => {
					this.onLongPressDeactivate();
					this.sm_window.next(state_backto_default);
				},
			});
			const state_backto_default = new MouseState({
				up: (e) => {
					e.stopPropagation();
					this.changeState();
				},
			});
			
			return this.long_press_active ? state_longpressed : state_default;
		},
		defaultStateTitle: function() {
			if (!this.isEditable) {
				if(this.$store.getters.isDisplayListTypeMember && this.isParent)
					return this.state_nop;
				
				const state_watch_default = new MouseState({
					down: (e) => {
						let obj = e.targetTouches ? e.targetTouches[0] : e;
						this.mouse_pointer.x = obj.screenX;
						this.mouse_pointer.y = obj.screenY;
					},
					up: (e) => {
						let obj = e.changedTouches ? e.changedTouches[0] : e;
						let diff_x = Math.abs(this.mouse_pointer.x - obj.screenX);
						let diff_y = Math.abs(this.mouse_pointer.y - obj.screenY);
						if ((diff_x < THRESHOLD) && (diff_y < THRESHOLD)) {
							this.sm_title.next(state_watch_click);
						} else {
							this.changeState();
						}
					},
				});
				const state_watch_click = new MouseState({
					longclick: (e) => {
						e.stopPropagation();
						this.changeState();
					},
					click: (e) => {
						e.stopPropagation();
						this.$emit("progress-rate-setting", {
							schedule: this.schedule,
							item_type: this.parent.item_type,
							callback: () => {
								this.changeState();
							},
						});
					},
				});
				
				return state_watch_default;
			}
			const state_longpressed = new MouseState({
				click: (e) => {
					e.stopPropagation();
					this.$emit("progress-rate-setting", {
						schedule: this.schedule,
						item_type: this.parent.item_type,
						callback: () => {
							this.onLongPressDeactivate();
							this.changeState();
						},
					});
				},
			});
			return this.long_press_active ? state_longpressed : this.state_nop;
		},
		updateDataSet: function() {
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				this.fetchData();
			};
			const onTokenFail = () => {
				this.logout();
			};
			this.dataset_manager.setAfterDataset();
			this.dataset_manager.sync(null, onFail, onTokenFail);
		},
		fetchData: async function() {
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			await this.dataset_manager.fetch(access_token)
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch(async (e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					this.$store.commit('addNotification', notification);
				});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		classChartBar: function() {
			let classes = new Array();

			if (this.isEditable && !this.long_press_active)
				classes.push('bar-move');
			if (this.isEditable && this.long_press_active)
				classes.push('bar-clickable');
			
			if (this.isParent) {
				classes.push('project');
			} else {
				classes.push('member');
			}

			return classes;
		},
		classSchedule: function() {
			let classes = new Array();
			
			if (this.long_press_active)
				classes.push('long-pressed');
			
			return classes;
		},
		classBothEnds: function() {
			let classes = new Array();
			
			if (this.isEditable && !this.long_press_active)
				classes.push('bar-resize');
			
			return classes;
		},
		classProgressRateLabel: function() {
			let classes = new Array();
			if (this.isEditable && !this.long_press_active)
				classes.push('bar-move');
			if (this.isEditable && this.long_press_active)
				classes.push('bar-clickable');

			return classes;
		},
		styleChartBar: function() {
			let base_date = this.$store.getters.calendarBaseDate;
			let tick_width = UNIT_WIDTH.TICK / this.$store.getters.unitTicks;
			
			let offset_begin_ticks = this.schedule.begin.offsetTicks(base_date);
			let ticks = this.schedule.ticks;
			
			let left = offset_begin_ticks * tick_width;
			
			return {
				"bottom":"11px",
				"left": left + "px",
				"width": (ticks * tick_width) + 'px',
			};
		},
		styleScheduleColor: function() {
			let color = this.hexColor;
			if (this.$store.getters.isDisplayListTypeMember && this.isParent)
				color = '#808080';
			return {
				'background-color': color,
			};
		},
		styleProgressRateBody: function() {
			return {
				'background-color': this.hexColor,
				"width": this.schedule.progress_rate + '%',
			};
		},
		hexColor: function() {
			let color = this.createColor(this.schedule.color_code);
			if (color.isDefaultColor) {
				if (this.$store.getters.isDisplayListTypeMember) {
					let member = this.$store.getters.mstMemberData(this.schedule.member_code);
					color = this.createColor(member.color_code);
				} else {
					color = this.createColor(this.parent.color_code);
				}
			}
			return color.asHex;
		},
		createColor: function() {
			return function(code) {
				let type = this.parent.item_type === ScheduleListRow.ITEM_TYPE.PROJECT
					? Color.RELATION_TYPE.PROJECT
					: Color.RELATION_TYPE.MEMBER;
				return this.$store.getters.displayColor(code, type);
			};
		},
		styleTriangleLeft: function() {
			let classes = new Array();
			if(this.showTriangle) {
				classes.push('triangle-left');
				if (this.isParent) {
					classes.push('triangle-left-parent-color');
				} else {
					classes.push('triangle-left-children-color');
				}
			}
			
			return classes;
		},
		styleTriangleRight: function() {
			let classes = new Array();
			if(this.showTriangle) {
				classes.push('triangle-right');
				if (this.isParent) {
					classes.push('triangle-right-parent-color');
				} else {
					classes.push('triangle-right-children-color');
				}
			}
			
			return classes;
		},
		showTriangle: function() {
			return this.isEditable && !this.long_press_active
		},
		showProgressRate: function() {
			if(this.$store.getters.isDisplayListTypeProject){	
				return this.schedule.progress_rate != 0;
			} else {
				return !this.isParent && this.schedule.progress_rate != 0;
			}
		},
		captionProgressRate: function() {
			return this.schedule.progress_rate + "%";
		},
		getProjectPinned: function() {
			let pinned = this.$store.getters.projectPinned(this.schedule.project_code);
			
			if (pinned === undefined) {
				pinned = this.$store.getters.projectPinned('default');
			}
			return pinned;
		},
	},
	watch: {
		isEditable: function() {
			this.long_press_active = false;
			this.sm_bar.next(this.defaultStateBar());
			this.sm_begin.next(this.defaultStateBegin());
			this.sm_end.next(this.defaultStateEnd());
			this.sm_title.next(this.defaultStateTitle());
		},
	},
	created: function() {
		this.sm_window.bind(window);
	},
	beforeDestroy: function() {
		this.sm_window.unbind(window);
	},
}
</script>
<style>
	.gb-chart-bar {
		display: inline-block;
		margin-top: 10px;
		height: 27px;
		position: absolute;
		border-radius: 13px;
		border-style: none;
		text-align: center;
	}
	.schedule {
		position: absolute;
		height: 100%;
		width:100%;
		opacity: .6;
		border-radius: 13px;
	}
	
	.gb-chart-bar .left {
		position: absolute;
		left: 0;
		display: inline-block;
		
		height: 27px;
		width: 10px;
	}

	.gb-chart-bar .right {
		position: absolute;
		right: 0;
		display: inline-block;
		height: 27px;
		width: 10px;
	}
	
	.gb-chart-bar.bar-move {
		cursor: move;
	}
	.lable-progress-rate {
		right: -33px;
		position: absolute;
		color: black;
		bottom: 2px;
	}
	.lable-progress-rate.bar-move {
		cursor: move;
	}
	.gb-chart-bar .bar-resize {
		cursor: w-resize;
	}

	.schedule.long-pressed {
		border-width: 3px;
		border-style: solid;
		border-color: rgba(255, 0, 0, 1);
	}

	.triangle-left {
		position: absolute;
		top: 6px;
		left: 3px;
		width: 0;
		height: 0;
		border-top: 7px solid transparent;
		border-bottom: 7px solid transparent;
		border-right: 7px solid;
	}

	.triangle-left-parent-color {
		border-right-color: #E0E0FF;
	}

	.triangle-left-children-color {
		border-right-color: #E0FFE0;
	}

	.triangle-right {
		position: absolute;
		top: 6px;
		right: 5px;
		width: 0;
		height: 0;
		border-top: 7px solid transparent;
		border-bottom: 7px solid transparent;
		border-left: 7px solid;
	}

	.triangle-right-parent-color {
		border-left-color: #E0E0FF;
	}

	.triangle-right-children-color {
		border-left-color: #E0FFE0;
		
	}
	.propgress-rate {
		position: absolute;
		height: 100%;
		width: 100%;
		border-radius: 13px;
		overflow: hidden;
		left: 0;
	}
	.progress-rate-body {
		height: 100%;
		opacity: .6;
	}
	
	.btn-progress-rate {
		width: 100%;
		position: absolute;
		color:white;
	}
	.bar-stretch {
		position: absolute;
		width: 100%;
		z-index: 102;
	}

	.bar-clickable {
		cursor: pointer !important;
	}
	.bar-name {
		height: 1.5rem;
		overflow: hidden;
		word-wrap: normal;
		text-align: left;
		padding: 3px 0px 3px 0px;
		margin: 0px 15px 0px 15px;
		
	}
	.lable-title {
		left: 5px;
		position: absolute;
		color: black;
		top: -15px;
		white-space: nowrap;
		padding: 0px 2px 0px 2px;
		background-color:#fefefe;
		text-align: left;
		font-size: 10px;
		padding: 0px 5px 0px 5px;
		border-bottom: 1px solid gray;
		border-left: 1px solid #c3c3c3;
		box-shadow: 2px 2px 4px grey;
		z-index: 101;
		cursor: default;
	}
</style>
<style scoped>
	.v-btn--floating {
		position: absolute;
		right: -12px;
		top: -12px;
		opacity: 1;
	}

	.v-btn--floating.v-btn--small {
		width: 16px;
		height: 16px;
	}
</style>
